function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3340",
  "data-name": "Group 3340",
  transform: "translate(-164.002 -151.313)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_685",
  "data-name": "Group 685",
  transform: "translate(337.762 316.818) rotate(180)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_682",
  "data-name": "Group 682"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_681",
  "data-name": "Group 681"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1438",
  "data-name": "Rectangle 1438",
  width: 0.747,
  height: 13.668,
  transform: "translate(168.506 151.313)",
  fill: "#0196e1"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_684",
  "data-name": "Group 684"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_683",
  "data-name": "Group 683"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_931",
  "data-name": "Path 931",
  d: "M173.759,160.686l-4.82,4.82L164,160.689l.522-.535,4.409,4.3,4.3-4.3Z",
  fill: "#0196e1"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_686",
  "data-name": "Group 686",
  transform: "translate(0 6.761)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1439",
  "data-name": "Rectangle 1439",
  width: 11.487,
  height: 0.75,
  transform: "translate(170.726 151.649)",
  fill: "#0196e1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_687",
  "data-name": "Group 687",
  transform: "translate(0 6.761)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1440",
  "data-name": "Rectangle 1440",
  width: 9.362,
  height: 0.75,
  transform: "translate(170.726 154.649)",
  fill: "#0196e1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_688",
  "data-name": "Group 688",
  transform: "translate(0 6.761)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1441",
  "data-name": "Rectangle 1441",
  width: 5.362,
  height: 0.75,
  transform: "translate(170.726 157.649)",
  fill: "#0196e1"
})));

function SvgAscending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.211,
    height: 14.193,
    viewBox: "0 0 18.211 14.193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscending);
export default __webpack_public_path__ + "static/media/ascending.182e72d8.svg";
export { ForwardRef as ReactComponent };